import clsx from 'clsx';
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';

import { AppSidebar } from './app-sidebar';
import { SourceUniversalSearch } from './universal-search';
import { useWxCopilotContext } from './wx-copilot-host/context';

export function Layout() {
  const { isPanelOpen } = useWxCopilotContext();
  const { openingSlug } = useParams();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  // A table reads its search and filters from the URL only on mount, so a
  // palette jump to the page already open ("See all" from All Campaigns)
  // remounts it to apply the new query.
  const [pageKey, setPageKey] = useState(0);
  const remountPage = useCallback(() => setPageKey(key => key + 1), []);

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0 });
  }, [openingSlug]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <div
        ref={scrollContainerRef}
        className={clsx(
          'relative flex flex-1 flex-col overflow-auto',
          isPanelOpen && 'mr-[400px]',
        )}
      >
        <Fragment key={pageKey}>
          <Outlet />
        </Fragment>
      </div>
      <SourceUniversalSearch onNavigated={remountPage} />
    </SidebarProvider>
  );
}
